module.exports = __webpack_public_path__ + "img/katarina_kitchen_4.f9405221.jpg";